import { Pipe, PipeTransform } from '@angular/core';
import { MixtureCategoryDTO } from '@scip/api';

@Pipe({
  name: 'mixtureCategoryChip'
})
export class MixtureCategoryChipPipe implements PipeTransform {
  transform(value: MixtureCategoryDTO, isTooltip: boolean = false): string {
    if (!value || !value.text) {
      return '';
    }
    if (isTooltip) {
      return value.identifier + ': ' + value.text;
    } else {
      return value.text;
    }
  }
}
